import React, {useEffect} from 'react';
import {observer} from 'mobx-react-lite'
import PhoneInput from 'react-phone-input-2'

const Phone = ({store, prop, value, country, valid, required=false, ...rest}) => {
  return (
    <PhoneInput
      country={country} // Default country
      value={store[prop]}
      onChange={(phone) => {
        store.setProperty(prop, phone)
      }}
      inputClass={`form-control${required && store.was_validated && !store[valid] ? ' invalid': ''}`}
      containerClass="phone-input-container"
      {...rest}
    />
  );
}

export default observer(Phone);